import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { hasValidAuthSession } from '@/utils/sessionUser';

const LoadingScreen = () => (
  <div className="min-h-screen flex items-center justify-center bg-[#0a0f1a] text-white">
    <p className="animate-pulse text-sm text-white/60">Carregando…</p>
  </div>
);

const ProtectedRoute = ({ children }) => {
  const { user, loading, refreshUser } = useAuth();
  const location = useLocation();
  const [hydrating, setHydrating] = useState(false);

  const hasSession = hasValidAuthSession();

  useEffect(() => {
    if (loading || user || !hasSession || hydrating) {
      return;
    }
    setHydrating(true);
    refreshUser().finally(() => setHydrating(false));
  }, [loading, user, hasSession, hydrating, refreshUser]);

  if (loading || hydrating || (hasSession && !user)) {
    return <LoadingScreen />;
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }

  return children;
};

export default ProtectedRoute;
